import { render, staticRenderFns } from "./UIBackBtn.vue?vue&type=template&id=675da0a6&scoped=true&"
import script from "./UIBackBtn.vue?vue&type=script&lang=ts&"
export * from "./UIBackBtn.vue?vue&type=script&lang=ts&"
import style0 from "./UIBackBtn.vue?vue&type=style&index=0&id=675da0a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675da0a6",
  null
  
)

export default component.exports